import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guardián de ruta funcional que restringe el acceso a vistas protegidas
 * redireccionando al usuario al login si no tiene una sesión activa.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si el Signal computed de autenticación es verdadero, se permite el acceso
  if (authService.isAuthenticated()) {
    return true;
  }

  // Redireccionar al login en caso contrario
  return router.createUrlTree(['/login']);
};
